// @ts-nocheck
import { createTypedReducerWithImmer } from "@insite/client-framework/Common/CreateTypedReducer";
import { setDataViewLoaded, setDataViewLoading } from "@insite/client-framework/Store/Data/DataState";
import { AlternatePackagingCollectionModel } from "@store/Framework/Types/ApiModels";
import { GetAlternatePackagingApiParameter } from "@store/Framework/Services/AlternatePackagingService";
import ProductAlternatePackagingState from "@store/Framework/Store/Greif/Data/ProductAlternatePackaging/ProductAlternatePackagingState";
import { Draft } from "immer";

const initialState: ProductAlternatePackagingState = {
    isLoading: {},
    byId: {},
    dataViews: {},
    alternativeSummary: "",
    alternativeType: "",
    currentProductNumber: "",
};

const actions = {
    "Greif/Data/ProductAlternatePackaging/BeginLoadAlternatePackaging": (
        draft: Draft<ProductAlternatePackagingState>,
        action: { parameter: GetAlternatePackagingApiParameter },
    ) => {
        setDataViewLoading(draft, action.parameter);
    },

    "Greif/Data/ProductAlternatePackaging/CompleteLoadAlternatePackaging": (
        draft: Draft<ProductAlternatePackagingState>,
        action: {
            parameter: GetAlternatePackagingApiParameter;
            collection: AlternatePackagingCollectionModel;
        },
    ) => {
        setDataViewLoaded(draft, action.parameter, action.collection, collection =>
            Object(collection.alternatePackagingAttributes!),
        );
    },

    "Greif/Data/ProductAlternatePackaging/FailedToLoadAlternatePackaging": (
        draft: Draft<ProductAlternatePackagingState>,
        action: { model: AlternatePackagingCollectionModel },
    ) => {
        delete draft.isLoading[action.model.id];
        if (draft.errorStatusCodeById) {
            delete draft.errorStatusCodeById[action.model.id];
        }
    },

    "Greif/Data/ProductAlternatePackaging/Reset": () => {
        return initialState;
    },

    "Greif/Data/ProductAlternatePackaging/SetAlternatePackaging": (
        draft: Draft<ProductAlternatePackagingState>,
        action: {
            parameter: {
                alternativeSummary: string;
                alternativeType: string;
                currentProductNumber: string;
            };
        },
    ) => {
        draft.alternativeSummary = action.parameter.alternativeSummary;
        draft.alternativeType = action.parameter.alternativeType;
        draft.currentProductNumber = action.parameter.currentProductNumber;
    },
};

const reducer = createTypedReducerWithImmer(initialState, actions);
export type GreifDataAlternatePackagingActions = Parameters<typeof reducer>[1];
export default reducer;
